import 'datatables.net/js/jquery.dataTables.js';

$(document).on('turbo:load', function () {
  $.fn.dataTable.ext.errMode = 'none';

  // Plugin default behaviour is to display an alert on the screen if something went wrong
  $('.datatable').each(function () {
    var table = $(this);
    // protect against multiple initializations
    if (table.attr('initialized')) {
      return;
    }
    table.attr('initialized', true);

    $('.datatable').DataTable({
      fixedHeader: true,
      paginate: true,
      stateSave: true,
      processing: true,
      pageLength: 250,
      lengthMenu: [50, 100, 150, 200, 250],
      order: [],
    });
  });
});

// Destroy the data-table on page change
document.addEventListener('turbo:before-cache', function () {
  var dataTable = $('.datatable');
  if (dataTable !== null) {
    dataTable.DataTable().destroy();
    dataTable == null;
  }
});
